"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialCard = void 0;
exports.renderSocialSection = renderSocialSection;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
require("./SocialSection.css");
var _texts = require("../../texts");
var _SocialEditDialog = require("./SocialEditDialog");
var _collapsibleSection = require("../shared/collapsibleSection");
var _profileIcons = require("../../icons-svg/profileIcons");
const MAX_VISIBLE_SOCIAL_ACCOUNTS_MOBILE = 10;
function isRenderableAccount(account) {
  return Boolean(account?.homepage && account?.name && account?.icon);
}
function expandSocialAccounts(event) {
  const button = event.currentTarget;
  const socialCard = button?.closest('.social-card');
  if (!button || !socialCard) return;
  socialCard.setAttribute('data-mobile-expanded', 'true');
  button.setAttribute('aria-expanded', 'true');
  button.hidden = true;
}
const SocialCard = (SocialData, _viewerMode) => {
  const accounts = (SocialData.accounts || []).filter(isRenderableAccount);
  const hiddenAccountsCount = Math.max(0, accounts.length - MAX_VISIBLE_SOCIAL_ACCOUNTS_MOBILE);
  if (accounts.length) {
    return (0, _litHtml.html)`
      <section
        id="social-media"
        class="social-card"
        aria-label="Social media"
        SocialData: SocialPresentation
      >
        <nav aria-label="Social media profiles">
          <ul class="social-card__list" role="list">
            ${accounts.map(account => renderAccount(account))}
          </ul>
        </nav>
        ${hiddenAccountsCount > 0 ? (0, _litHtml.html)`
              <solid-ui-button
                type="button"
                variant="secondary"
                size="sm"
                label=${`${hiddenAccountsCount} more`}
                class="social-card__more-button"
                aria-controls="social-media"
                aria-expanded="false"
                @click=${expandSocialAccounts}
              >
                ${hiddenAccountsCount} more
              </solid-ui-button>
            ` : (0, _litHtml.html)``}
      </section>
    `;
  }
  return (0, _litHtml.html)``;
  function renderAccount(account) {
    return (0, _litHtml.html)`
      <li class="social-card__item" role="listitem">
        <a 
          class="social-card__link"
          href="${account.homepage}" 
          target="_blank" 
          rel="noopener noreferrer" 
          aria-label="Visit ${account.name} profile (opens in new tab)"
        >
          <img 
            class="social-card__icon" 
            src="${account.icon}" 
            alt="${account.name} icon"
            width="40"
            height="40"
            loading="lazy"
          />
        </a>
      </li>
    `;
  }
};
exports.SocialCard = SocialCard;
function renderSocialSectionContent(socialData, viewerMode) {
  const hasAccounts = socialData.accounts && socialData.accounts.length > 0;
  return (0, _litHtml.html)`
    ${hasAccounts ? SocialCard(socialData, viewerMode) : (0, _litHtml.html)`<p>No social accounts added yet.</p>`}
  `;
}
function renderSocialSectionDefault(store, subject, socialData, viewerMode, onSaved) {
  // const hasAccounts = socialData.accounts && socialData.accounts.length > 0
  const showSection = true;
  const isOwner = viewerMode === 'owner';
  const handleEdit = event => {
    return (0, _SocialEditDialog.createSocialEditDialog)(event, store, subject, socialData.accounts, viewerMode, onSaved);
  };
  return showSection ? (0, _litHtml.html)`
        <section 
          aria-labelledby="social-heading" 
          data-profile-section="social"
          class="profile__section profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
          role="region"
          tabindex="-1"
          data-expanded="false"
        >
          <header class="profile__section-header profile-section-collapsible__header">
            <h3 id="social-heading" tabindex="-1">${_texts.socialAccountsHeadingText}</h3>
            <div class="profile-section-collapsible__actions">
              ${isOwner ? (0, _litHtml.html)`
                <solid-ui-button
                  type="button"
                  variant="secondary"
                  size="sm"
                  class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
                  aria-label="Edit social accounts"
                  @click=${handleEdit}
                >
                  <span class="profile-section-collapsible__edit-label profile__add-more-content">
                    <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
                    <span>Add More</span>
                  </span>
                  <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
                </solid-ui-button>
              ` : (0, _litHtml.html)``}
              <solid-ui-button
                type="button"
                variant="icon"
                size="sm"
                class="profile-section-collapsible__toggle-button"
                aria-label="Toggle social accounts section"
                aria-controls="social-panel"
                aria-expanded="false"
                @click=${_collapsibleSection.toggleCollapsibleSection}
              >
                <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
              </solid-ui-button>
            </div>
          </header>
          <div id="social-panel" class="profile-section-collapsible__content">
            ${renderSocialSectionContent(socialData, viewerMode)}
          </div>
        </section>
      ` : (0, _litHtml.html)``;
}
function renderOwnerEmptySocialContent(_store, _subject, _socialData, _viewerMode, _onSaved) {
  return (0, _litHtml.html)`
      <div class="profile__empty-state-content" role="group" aria-label="Empty social accounts section">
        <div class="social__empty-icon-wrapper">
          <span class="social__empty-icon">${_profileIcons.globeIcon}</span>
        </div>
        <p class="profile__empty-state-message social__empty-message">
            No social media links added yet.
        </p>
      </div>
  `;
}
function renderOwnerEmptySocialSection(store, subject, socialData, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="social-heading" 
      data-profile-section="social"
      class="profile__section--empty profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h3 id="social-heading" tabindex="-1">${_texts.socialAccountsHeadingText}</h3>
        <div class="profile-section-collapsible__actions">
          <solid-ui-button
            type="button"
            variant="secondary"
            size="sm"
            class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
            aria-label="Add social accounts"
            @click=${event => {
    return (0, _SocialEditDialog.createSocialEditDialog)(event, store, subject, socialData.accounts, viewerMode, onSaved);
  }}
          >
            <span class="profile-section-collapsible__edit-label profile__add-more-content">
              <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
              <span>Add More</span>
            </span>
            <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
          </solid-ui-button>
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle social accounts section"
            aria-controls="social-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="social-panel" class="profile-section-collapsible__content">
        ${renderOwnerEmptySocialContent(store, subject, socialData, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderSocialSection(store, subject, socialData, viewerMode, onSaved) {
  const safeSocialData = socialData || {
    accounts: []
  };
  const hasAccounts = Array.isArray(safeSocialData.accounts) && safeSocialData.accounts.length > 0;
  const showOwnerEmptyAccounts = !hasAccounts && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyAccounts ? renderOwnerEmptySocialSection(store, subject, safeSocialData, viewerMode, onSaved) : renderSocialSectionDefault(store, subject, safeSocialData, viewerMode, onSaved)}
  ` : '';
}